// extracted by mini-css-extract-plugin
export default {"restoreLink":"RestoreLink_restoreLink__IsIY6","placeHolderShimmer":"RestoreLink_placeHolderShimmer__iEa6Z"};